import { useEffect, useState } from 'react';

import { isCopEnabled } from '../../services/cookieUtils';

export type CopLogoutProps = {
    readonly buttonlabel?: string;
    readonly buttonurl?: string;
};

export default function CopLogout({ buttonlabel, buttonurl }: CopLogoutProps) {
    const [isSystemAdmin, setIsSystemAdmin] = useState(false);
    const [isUserManager, setIsUserManager] = useState(false);

    useEffect(() => {
        try {
            const raw = sessionStorage.getItem('cop:current-user')
            if (raw) {
                const user = JSON.parse(raw) as { isSystemAdmin?: boolean; isUserManager?: boolean }
                setIsSystemAdmin(user.isSystemAdmin === true)
                setIsUserManager(user.isUserManager === true)
            }
        } catch {
            // non-fatal — button stays hidden if session data is unavailable
        }
    }, [])

    // Non-COP users (cop_powerportal_flag cookie !== 'true') must never see the Admin Mode button
    if (!buttonurl || !isCopEnabled() || (!isSystemAdmin && !isUserManager)) {
        return null;
    }

    return (
        <div className="cmp-button cmp-header__top-item-title cmp-header__top-item-admin-mode">
            <a href={buttonurl}>
                <span className="cmp-header__top-item-title-icon cmp-button__icon cmp-button__icon--profile"></span>
                <span className="cmp-header__top-item-title-text">
                    {buttonlabel || 'Admin Mode'}
                </span>
            </a>
        </div>
    );
}
